export default __webpack_public_path__ + "static/media/newsTwo.5d579633.jpg";